<!-- SearchBar.vue -->
<template>
  <form @submit.prevent="search">
    <div class="search-box">
      <input class="search-input" v-model="searchQuery" placeholder="Pesquisar..." type="text" />
      <button type="submit" class="search-button"><v-icon color="#fff">fa fa-search</v-icon></button>
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      searchQuery: ""
    };
  },
  methods: {
    search() {
      this.$router.push({ name: "results", query: { tag: this.searchQuery } });
    }
  }
};
</script>

<style scoped>
.search-box {
  display: flex;
  padding: 8px;
  border-radius: 5px;
  border: 1px solid #ccc;
  width: 200px;
  margin-right: 10px;
  position: relative;
}

.search-button {
  position: absolute;
  right: 10px;
}

.search-input {
  color: #fff;
  width: 80%;
}

.search-input::placeholder {
  color: #fff;
}
</style>
